/**
 * 会議操作対象タイプ
 */
export var SessionActionTargetTypes;

(function (SessionActionTargetTypes) {
  /**
   * 未定義
   */
  SessionActionTargetTypes[SessionActionTargetTypes["Unknown"] = 0] = "Unknown";
  /**
   * 会議
   */

  SessionActionTargetTypes[SessionActionTargetTypes["Session"] = 1] = "Session";
  /**
   * 素材
   */

  SessionActionTargetTypes[SessionActionTargetTypes["Material"] = 2] = "Material";
  /**
   * メンバー
   */

  SessionActionTargetTypes[SessionActionTargetTypes["Member"] = 3] = "Member";
  /**
   * ブロードキャスト
   */

  SessionActionTargetTypes[SessionActionTargetTypes["Broadcast"] = 4] = "Broadcast";
  /**
   * キャプチャ
   */

  SessionActionTargetTypes[SessionActionTargetTypes["Capture"] = 5] = "Capture";
  /**
   * 画面共有
   * */

  SessionActionTargetTypes[SessionActionTargetTypes["ScreenSharing"] = 6] = "ScreenSharing";
  /**
   * オーサリング
   */

  SessionActionTargetTypes[SessionActionTargetTypes["Authoring"] = 7] = "Authoring";
  /**
   * ストリーミング
   */

  SessionActionTargetTypes[SessionActionTargetTypes["Streaming"] = 8] = "Streaming";
  /**
   * 音声メモ
   */

  SessionActionTargetTypes[SessionActionTargetTypes["VoiceMemo"] = 9] = "VoiceMemo";
  /**
   * 付箋
   */

  SessionActionTargetTypes[SessionActionTargetTypes["StickyNote"] = 10] = "StickyNote";
  /**
   * 同時翻訳
   */

  SessionActionTargetTypes[SessionActionTargetTypes["Translation"] = 11] = "Translation";
  /**
   * チャットボット
   */

  SessionActionTargetTypes[SessionActionTargetTypes["ChatBot"] = 12] = "ChatBot";
})(SessionActionTargetTypes || (SessionActionTargetTypes = {}));